import React, { useState } from "react";
import InputTextField from "../../components/textField/InputTextField";
import "./radio.scss";
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { EmailIcon, FedExIcon, PhoneIcon, UpsIcon } from "../../icons/svg";

const MuiRadio = ({
  defaultValue,
  options,
  label,
  onChange,
  value,
  required = false,
  image = false,
  error,
  onInputChange,
  customerSuppliedField = null,
  customerSuppliedFieldValue,
  setActiveInnerStep = null,
  activeInnerStep,
  ...rest
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const customerSuppliedOptions = [{id: 58, name: "Valve"}, {id: 50, name: "Plate"}, {id: 43, name: "Lock"}, {id: 22, name: "Fabric"}]

  const handleRadioChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className="radioGroup">
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label">
          {label} {required ? <span style={{ color: "red" }}>*</span> : ""}
        </FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={selectedValue}
          onChange={handleRadioChange}
          name="radio-buttons-group"
          defaultValue={defaultValue}
          row
          {...rest}
        >
          {options.map((option, index) => (
            <div key={index}>
            <FormControlLabel
              value={option.id}
              control={<Radio />}
              checked={defaultValue === option?.id ? true : false}
              label={
                <div className="radioLabel">
                  <div className="radioIcon">
                    {option.methodName === "Email" && (
                      <span>
                        <EmailIcon />
                      </span>
                    )}
                    {option.methodName === "Phone" && (
                      <span>
                        <PhoneIcon />
                      </span>
                    )}
                    {option.img && <img src={option.img} alt="brim" />}
                    <span> {option.displayName}</span>
                    {option.methodName && <span>{option.methodName}</span>}
                    {option.carrierName && <span>{option.carrierName}</span>}
                    {option.carrierName === "UPS" && <UpsIcon />}
                    {option.carrierName === "FedEx" && <FedExIcon />}
                  </div>
                  {option?.partNumbers && <p>{option.partNumbers[0]}</p>}

                  {option.suffix && (
                    <div className="additional-content">{option.suffix}</div>
                  )}
                  {option.content && parseInt(selectedValue) === option?.id ? (
                    <div>{option.content}</div>
                  ) : null}
                </div>
              }
              className={`${
                defaultValue !== null && parseInt(selectedValue) === option?.id
                  ? "checkedLabel"
                  : defaultValue === option?.id
                  ? "checkedLabel"
                  : ""
              }`}
            />
              {(customerSuppliedField !== null &&
                customerSuppliedOptions.find(({ id }) => id === option?.id) !== undefined &&
                customerSuppliedOptions.find(({ id }) => id === parseInt(defaultValue)) !== undefined) ?
                <div className="radioGroup mt-3">
                  <div className="radioLabel">
                    <InputTextField
                      label={option?.displayName + " Name"}
                      variant="outlined"
                      placeholder={customerSuppliedOptions.find(({id}) => id === option?.id).name}
                      type="text"
                      required={false}
                      value={customerSuppliedFieldValue}
                      fullWidth={true}
                      onChange={(e) => {
                        if (setActiveInnerStep !== null) {
                          setActiveInnerStep(activeInnerStep);
                        }
                        onInputChange(e, customerSuppliedField)
                      }}
                    />
                  </div>
                </div>
                : <></>}
            </div>
          ))}
        </RadioGroup>
      </FormControl>
      {error && (
        <Alert
          severity="error"
          style={{ padding: "0px 16px", marginTop: "12px" }}
        >
          Select an option
        </Alert>
      )}
    </div>
  );
};

export default MuiRadio;
